<app-popup-container>
    <app-popup-content class="mm-image-content">
        <img class="mm-image" [attr.src]="data.imageUrl"/>
    </app-popup-content>
</app-popup-container>
